import { MetaRoot } from 'util/metaPath'

import AtestadoModel, { CidadaoAtestado } from '../components/model-atestado'
import { getSolicitacaoFraldasGeriatricasText } from './utils-solicitacaoFraldasGeriatricas'

export const createSolicitacaoFraldasGeriatricasCalculations = (
  path: MetaRoot<AtestadoModel>,
  cidadao: CidadaoAtestado
) => [
  {
    field: path.naoPossui.absolutePath(),
    updates: {
      [path.cpfCns.absolutePath()]: (_, allValues: AtestadoModel) =>
        allValues.naoPossui ? undefined : allValues.cpfCns,
    },
  },
  {
    field: [
      path.tamanhoFralda.absolutePath(),
      path.unidadesPorDia.absolutePath(),
      path.cid10.absolutePath(),
      path.cpfCns.absolutePath(),
      path.naoPossui.absolutePath(),
    ],
    updates: {
      [path.descricao.absolutePath()]: (_, allValues: AtestadoModel) =>
        getSolicitacaoFraldasGeriatricasText({ cidadao, values: allValues }),
    },
  },
]
